import { OnChangeParams } from 'baseui/select';
import { useMemo } from 'react';
import { EnhancedLabeledSelect } from '../ui/EnhancedLabeledSelect';

type Props = {
  model?: number;
  onChangeYear?: (year?: number) => void;
  isFilter?: boolean;
  label?: string;
  emptyOptionText?: string;
  showEmptyOption?: boolean;
  error?: React.ReactNode;
  onBlur?: () => void;
  inline?: boolean;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  selectMaxWidth?: number;
};

function VehicleModelSelect({
  model,
  onChangeYear,
  isFilter = false,
  label = 'Modelo:',
  emptyOptionText = 'Selecciona un año',
  showEmptyOption = false,
  error,
  onBlur,
  inline,
  clearable = false,
  required = false,
  disabled = false,
  selectMaxWidth,
}: Readonly<Props>) {
  const yearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear + 1;
    const endYear = currentYear - 100;

    const yearsArray = Array.from({ length: startYear - endYear + 1 }, (_, i) => startYear - i).map((y) => ({
      id: y,
      label: y.toString(),
    }));

    return showEmptyOption
      ? [{ id: undefined, label: isFilter ? 'Todos' : emptyOptionText }, ...yearsArray]
      : yearsArray;
  }, [showEmptyOption, emptyOptionText, isFilter]);

  const onSelectedChange = (params: OnChangeParams) => {
    if (params.option?.id) {
      onChangeYear?.(params.option.id as number);
    } else {
      onChangeYear?.(undefined);
    }
  };

  return (
    <EnhancedLabeledSelect
      label={label}
      options={yearOptions}
      value={showEmptyOption || model !== undefined ? [{ id: model, label: model?.toString() }] : undefined}
      onChange={onSelectedChange}
      fullWidth
      onBlur={onBlur}
      searchable
      inline={inline}
      inset={inline}
      error={error}
      required={required}
      clearable={clearable}
      placeholder={emptyOptionText}
      disabled={disabled}
      selectMaxWidth={selectMaxWidth}
    />
  );
}

export default VehicleModelSelect;
